<template>
	<div class="buddie_dtl">
		<div class="dtl_title">
			<div class="left">
				<!-- 返回通话履历列表按钮 -->
				<div class="go_back" @click="goBack">
					<font-awesome-icon :icon="['fas', 'angle-left']" />
				</div>
				<!-- 个人信息（包含姓名） -->
				<div class="profile" v-if="user.name">
					<!-- 头像 -->
					<div class="avatar">
						<el-avatar :src="user.logo" size="small"></el-avatar>
					</div>
					<!-- 姓名和电话 -->
					<div class="name_phone">
						<span class="name">{{ user.name }}</span>
						<span class="phone">{{ `(${buddieNum})` }}</span>
					</div>
				</div>
				<!-- 个人信息（不包含姓名） -->
				<div class="profile" v-else>
					<!-- 头像 -->
					<div class="avatar">
						<el-avatar :src="user.logo" size="small"></el-avatar>
					</div>
					<!-- 电话 -->
					<div class="phone">{{ buddieNum }}</div>
				</div>
				<div class="rest"></div>
			</div>
			<!-- 操作按钮 -->
			<div class="right">
				<div class="title_btn">
					<!-- 拨打电话按钮 -->
					<div class="btn_item" @click="createCall">
						<font-awesome-icon :icon="['fas', 'phone']" />
					</div>
				</div>
			</div>
		</div>
		<div class="dtl_list">
			<div
				v-for="buddie in dataList"
				:class="
					buddie.SrcUserId == $SIP.profileUserID
						? 'buddies_msg'
						: 'buddies_msg in'
				"
				:key="buddie.CdrId"
			>
				<div class="msg_box">
					<div class="info">
						<div :class="buddie.Billsec > 0 ? 'icon answer' : 'icon'">
							<font-awesome-icon :icon="['fas', 'phone']" />
						</div>
						<div class="msg">
							{{ processMsg(buddie) }}
						</div>
					</div>
					<div class="time">
						{{ $SIP.utcToLocal(buddie.CallEnd) }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "BuddieDetail",
	props: ["buddieDtl", "user"],
	computed: {
		buddieNum() {
			let num = "";
			if (this.buddieDtl && this.buddieDtl.DataCollection) {
				num =
					this.buddieDtl.DataCollection[0].SrcUserId == this.$SIP.profileUserID
						? this.buddieDtl.DataCollection[0].Dst
						: this.buddieDtl.DataCollection[0].Src;
			}
			return num;
		},
		dataList() {
			return this.buddieDtl && this.buddieDtl.DataCollection
				? this.buddieDtl.DataCollection
				: [];
		},
		sipLang() {
			return this.$SIP.getLangText();
		},
	},
	mounted() {
		this.$nextTick(() => {
        let div = this.$el.querySelector(".dtl_list");
        div.scrollTop = div.scrollHeight;
      }); 
	},
	methods: {
		goBack() {
			this.$emit("closeBuddieDetail");
		},
		createCall() {
			this.goBack();
			this.$emit("createCall", this.buddieNum);
		},
		processMsg(buddie) {
			let str = "";
			let audioVideo = buddie.WithVideo
				? this.sipLang.a_video_call
				: this.sipLang.an_audio_call;
			if (buddie.SrcUserId == this.$SIP.profileUserID) {
				// (Outbound) You(profileUserID) initiated a call
				if (buddie.Billsec == 0) {
					str = `${this.sipLang.you_tried_to_make} ${audioVideo} (${
						buddie.ReasonText
					}).`;
				} else {
					str = `${this.sipLang.you_made} ${audioVideo} , ${
						this.sipLang.and_spoke_for
					} ${this.$SIP.formatDuration(buddie.Billsec)}.`;
				}
			} else {
				// (Inbound) you(profileUserID) received a call
				if (buddie.Billsec == 0) {
					str = `${this.sipLang.you_missed_a_call} (${buddie.ReasonText}).`;
				} else {
					str = `${this.sipLang.you_received} ${audioVideo} , ${
						this.sipLang.and_spoke_for
					} ${this.$SIP.formatDuration(buddie.Billsec)}.`;
				}
			}
			return str;
		},
	},
};
</script>

<style lang="scss" scoped>
.buddie_dtl {
	// height: 100%;
	padding-bottom: 12px;
	.dtl_title {
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		padding: 10px 2px;
		.left {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			.go_back {
				font-size: 20px;
				cursor: pointer;
				&:active {
					color: rgba($color: #000000, $alpha: 0.45);
				}
			}
			.profile {
				display: flex;
				align-items: center;
				column-gap: 10px;
				.avatar {
					margin-left: 5px;
				}
				.name_phone {
					column-gap: 5px;
				}
				.name {
					font-size: 16px;
					color: #333;
				}
				.phone {
					font-size: 14px;
					color: #5a5a5a;
				}
			}
		}
		.right {
			.btn_item {
				cursor: pointer;
			}
		}
	}
	.dtl_list {
    background: #efeadc;
    padding: 10px;
		height: calc(100% - 50px);
		// overflow-y: auto;
		.buddies_msg {
			display: flex;
      justify-content: flex-end;
			&.in {
        justify-content: flex-start;
				.msg_box {
					background: #ecf7e6;
					.time {
						text-align: left;
					}
				}
			}
			.msg_box {
				padding: 5px;
				background: #f1f9ff;
				border-radius: 5px;

				.info {
					display: flex;
					align-items: center;
					gap: 10px;
					margin-bottom: 5px;
					.icon {
						font-size: 13px;
						color: red;
            			margin-right: 5px;
						&.answer {
							color: green;
						}
					}
				}
				.time {
					font-size: 13px;
					color: #333;
          text-align: right;
				}
			}
		}
		.buddies_msg + .buddies_msg {
			margin-top: 10px;
		}
	}
}
</style>
